import "@/styles/pages/guide/guideList.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIsLoggedIn, setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { Col, Flex, Row } from "antd";
import ButtonComponent from "@/components/button/Button";
import {
  getFilteredGuide,
  getLastGuideSearchCriteria,
  setCurrentGuide,
  setFilteredGuide,
  setLastGuideSearchCriteria,
} from "@/reducers/guideSlice";
import IconTravelLang from "@/components/icons/IconTravelLang";
import IconBook from "@/components/icons/IconBook";
import IconSchoolCollege from "@/components/icons/IconSchoolCollege";
import { useNavigate } from "react-router-dom";
import { truncateString } from "@/helpers";
import { getGuideListBasedOnFilter } from "@/services/services/getGuideListBasedOnFilter";
import getCountryISO2 from "@/lib/data/isoThreeToTwo";

const GuideList = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const filteredGuide = useSelector(getFilteredGuide);
  const lastGuideSearchCriteria = useSelector(getLastGuideSearchCriteria);
  const navigate = useNavigate();
  const [guideData, setGuideData] = useState([]);
  // console.log(data, "data");
  // const data = {
  //   _id: 123,
  //   name: isLoggedIn
  //     ? "/assets/images/guideName.png"
  //     : "/assets/images/blurredName.png",
  //   isVerified: "/assets/images/verified.svg",
  //   profilePicture: isLoggedIn
  //     ? "/assets/images/guides.svg"
  //     : "/assets/images/bluredProfile.png",
  //   countryOne: "Delhi",
  //   countryTwo: "London",
  //   countryOneFlag: "/assets/images/in.svg",
  //   countryTwoFlag: "/assets/images/gb.svg",
  //   school: "London School of Economics",
  //   course: "International Development",
  //   language: "English, Hindi & Tamil",
  //   buttonTitle: "Book a Call",
  //   availableTime: "Available Today, 08:00pm IST",
  // };
  console.log(filteredGuide, "filteredGuide");
  useEffect(() => {
    if (isLoggedIn && lastGuideSearchCriteria) {
      getGuideListBasedOnFilter(lastGuideSearchCriteria)
        .then((response) => {
          dispatch(setLastGuideSearchCriteria(undefined));
          dispatch(setFilteredGuide(response));
        })
        .catch((error) => console.log("Error fetching mentor list:", error));
    }
  }, [isLoggedIn, dispatch, lastGuideSearchCriteria]);
  useEffect(() => {
    if (filteredGuide.length) {
      setGuideData(
        filteredGuide.map((x, index) => {
          return {
            ...x,
            heading: "Our Top Mentors:",
            name:
              isLoggedIn && !lastGuideSearchCriteria
                ? x.firstName + " " + x.lastName
                : `/assets/images/blurredName${index + 1}.png`,
            isVerified: "/assets/images/verified.svg",
            profilePicture:
              isLoggedIn && !lastGuideSearchCriteria
                ? x.profileImgUrl
                : `/assets/images/bluredProfile${index + 1}.png`,
            countryOne: x.country?.name,
            // countryTwo: "London",
            countryOneFlag: `https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${getCountryISO2(
              x?.country?.code
            )}.svg`,
            // countryTwoFlag: "/assets/images/gb.svg",
            school: x?.university?.name ?? "School Of Technology",
            course: x.courseName ?? "Computer Science",
            discipline: x?.discipline?.name,
            language: x?.languages?.length
              ? x?.languages.map((x) => x.name)?.join(", ")
              : ["English", "Hindi", "German"].join(", "),
            buttonTitle: "Book a Call",
            // availableTime: "Available Today, 08:00pm IST",
          };
        })
      );
    }
  }, [filteredGuide, isLoggedIn]);

  const handleBookCall = (guideData) => {
    if (isLoggedIn) {
      dispatch(setModalOpen(true));
      dispatch(setCurrentGuide(guideData));
      dispatch(setCurrentForm("bookASession"));
    } else {
      dispatch(setModalOpen(true));
      dispatch(setCurrentForm("signIn"));
    }
  };

  const handleReadMore = (guideData) => {
    if (isLoggedIn) {
      navigate(
        `/guideProfile/${guideData.firstName}-${guideData.lastName}/${guideData.country.code}/${guideData.id}`,
        { state: { guideData } }
      );
    } else {
      dispatch(setModalOpen(true));
      dispatch(setCurrentForm("signIn"));
    }
  };

  // console.log(guideData, "guideData");
  return (
    <div className="guide-cards">
      {guideData.map((guide, index) => (
        <div className="guide cursor-pointer" onClick={() => handleReadMore(guide)} key={index}>
          <Row
            gutter={[
              { xs: 13, sm: 13, md: 13, lg: 48 },
              { xs: 13, sm: 13, md: 13, lg: 48 },
            ]}
          >
            <Col xs={24} sm={24} md={13} lg={8} xl={6} className="guide-mobile">
              <div className="guide-profile-picture">
                <img src={guide.profilePicture} alt="Profile" />
              </div>
              <Col className="guide-mobile-view flex-1">
                <Row className="guide-profile">
                  <Col className="title-h5-2" style={{ width: "max-content", height: "32px" }}>
                    {!isLoggedIn || lastGuideSearchCriteria ? (
                      <img
                        src={guide.name}
                        style={{
                          width: "100%",
                          height: "40px",
                          objectFit: "contain",
                        }}
                        alt="Profile"
                      />
                    ) : (
                      <div className="guideName">{guide.name}</div>
                    )}
                  </Col>
                  <Col>
                    <img src={guide.isVerified} alt="" width="100%" height="100%" />
                  </Col>
                </Row>
                <Row>
                  <div className="country">
                    <img src={guide.countryOneFlag} alt="" />
                    <span className="body-b3 country-one">&nbsp;{guide.countryOne}</span>
                  </div>
                </Row>
              </Col>
            </Col>
            <Col xs={24} sm={24} md={11} lg={16} xl={9}>
              <div className="guide-info">
                <div className="guide-name">
                  <div className="title-h5-2" style={{ width: "max-content", height: "32px" }}>
                    {!isLoggedIn || lastGuideSearchCriteria ? (
                      <img
                        src={guide.name}
                        style={{
                          width: "100%",
                          height: "40px",
                          objectFit: "contain",
                        }}
                        alt="Profile"
                      />
                    ) : (
                      <div>{guide.name}</div>
                    )}
                  </div>
                  <div>
                    <img src={guide.isVerified} alt="" width="100%" height="100%" />
                  </div>
                </div>
                <div className="country">
                  <img src={guide.countryOneFlag} alt="" />
                  <span className="body-b3 country-one">&nbsp;{guide.countryOne}</span>
                  {/* {" "}
                  <div className="divider"></div>
                  <img src={guide.countryTwoFlag} alt="" />
                  <span className="body-b3">&nbsp;{guide.countryTwo}</span> */}
                </div>
                <div className="body-b3">
                  <Flex gap="10px" className="location">
                    <IconSchoolCollege /> <span>{guide.school}</span>
                  </Flex>
                </div>
                <div className="body-b3">
                  <Flex gap="10px" className="location">
                    <IconBook />
                    <span>
                      {guide.discipline === "Other" || !guide.discipline
                        ? guide.course
                        : guide.discipline}
                    </span>
                  </Flex>
                </div>
                <div className="body-b3">
                  <Flex gap="10px" className="language">
                    <IconTravelLang />{" "}
                    {guide.language ? <span>{guide.language}</span> : <span>-</span>}
                  </Flex>
                </div>
                {isLoggedIn ? (
                  <div className="body-b3 guide-mobile-description">
                    {/* <span>{`Hi, ${guide.name}, a ${guide.school} student. I excel at
                  guiding students like you through...`}</span> */}
                    {<span>{truncateString(guide.aboutMe, 100)}</span>}
                    <span className="read-more" onClick={() => handleReadMore(guide)}>
                      Read more
                    </span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={9}>
              <Flex gap={"10px"} className="guide-info">
                <ButtonComponent
                  type="primary"
                  label={guide.buttonTitle}
                  className="guide-card-button"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleBookCall(guide);
                  }}
                />
                {/* <div className="guide-card-footer body-b4">
                  {guide.availableTime}
                </div> */}
                <ButtonComponent
                  label="Play Intro"
                  className="guide-card-button"
                  iconRight={false}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (isLoggedIn) {
                      dispatch(setCurrentForm("videoPlayer"));
                      dispatch(setModalOpen(true));
                      dispatch(
                        setFormProps({
                          url: guide.introVidUrl,
                        })
                      );
                    } else {
                      dispatch(setModalOpen(true));
                      dispatch(setCurrentForm("signIn"));
                    }
                  }}
                >
                  <img src="/assets/images/play-pause.svg" alt="" />
                </ButtonComponent>
              </Flex>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default GuideList;
